<template lang="html">
  <div v-if="isVisible" class="item-content">
    <Ticket
      v-for="ticket in tickets"
      :ticket="ticket"
      :event_map="event_map"
      :interest_mode="interest_mode"
      :key="ticket.id">
    </Ticket>
  </div>
</template>

<script>
  import Ticket from './Ticket'


  export default {
    props: {
      isVisible: {
        type: Boolean,
        required: true
      },

      tickets: {
        type: Array,
        required: true
      },

      event_map: {
        type: String,
        required: false
      },

      interest_mode: {
        type: String,
        required: false
      }
    },

    components: {
      Ticket
    }
  }
</script>

<style lang="scss" scoped>
  .item-content {
    margin-bottom: 1rem;
  }
</style>
